<template>
  <v-snackbar v-model="show" top color="primary" auto-height>
    <span v-html="makeErrorString(message)" class="message"></span>
    <v-btn flat color="white" @click.native="show = false">{{ $t('action_close') }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: [],
      color: 'blue'
    };
  },
  created: function() {
    this.$store.watch(
      state => state.snack,
      () => {
        const msg = this.$store.state.snack;
        if (msg !== '') {
          this.show = true;
          this.message = this.$store.state.snack;
          this.$nextTick(() => {
            this.$store.commit('setSnack', '');
          });
        }
      }
    );
  },
  methods: {
    makeErrorString(messages) {
      return messages.map(m => `<p>${m.replace(/\n|\r\n|\r/g, '<br>')}</p>`).join('<br>');
    }
  }
};
</script>
<style lang="scss">
.message p {
  margin-bottom: 5px !important;
}
</style>
